const FeedIconSVG = ({ className }) => (
    <svg
        className={className}
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1 9C1 5.229 1 3.343 2.172 2.172C3.344 1.001 5.229 1 9 1H11C14.771 1 16.657 1 17.828 2.172C18.999 3.344 19 5.229 19 9V13C19 16.771 19 18.657 17.828 19.828C16.656 20.999 14.771 21 11 21H9C5.229 21 3.343 21 2.172 19.828C1.001 18.656 1 16.771 1 13V9Z"
            stroke="currentColor"
            strokeOpacity="1"
        />
        <path
            d="M4 11C4 9.586 4 8.879 4.44 8.44C4.878 8 5.585 8 7 8H13C14.414 8 15.121 8 15.56 8.44C16 8.879 16 9.586 16 11V15C16 16.414 16 17.121 15.56 17.56C15.121 18 14.414 18 13 18H7C5.586 18 4.879 18 4.44 17.56C4 17.122 4 16.415 4 15V11Z"
            stroke="currentColor"
            strokeOpacity="1"
        />
        <path
            d="M5 5H10"
            stroke="currentColor"
            strokeOpacity="1"
            strokeLinecap="round"
        />
    </svg>
);

export default FeedIconSVG;
